import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/icons/Logo.jpeg"; // 1. Import your PDF Play logo
import "./Footer.css"; // 2. We will create this new CSS file

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-column footer-logo-column">
          {/* Use the PDF Play logo */}
          <Link to="/" className="footer-logo">
            <img src={logo} alt="PDF Play Logo" className="footer-logo-img" />
          </Link>
          {/* Use the PDF Play tagline from your homepage screenshot */}
          <p className="footer-tagline">
            "Click. Convert. Create. Merge. Everything your PDF ever needed."
          </p>
        </div>

        <div className="footer-column">
          <h4>Company</h4>
          <a href="/about" class="footer-link">About Us</a>
         <a href="/contact" class="footer-link">Contact Us</a>
          <a href="/pricing" class="footer-link">Pricing</a>
         
    <Link to="/all-tools" class="footer-link">All Tools</Link>
    
        </div>

        <div className="footer-column">
          <h4>Legal</h4>
          <a href="/terms" class="footer-link">Terms and Conditions</a>
         <a href="/privacy" class="footer-link">Privacy Policy</a>
          <a href="/security" class="footer-link">Security</a>
           <a href="/faq" class="footer-link">FAQs</a>
            <a href="/reviews" class="footer-link">Reviews</a>
        </div>

        <div className="footer-column">
          <h4>Follow Us</h4>
          <div className="footer-social-icons">
            {/* Facebook Icon */}
            <a
              href="https://www.facebook.com/profile.php?id=61585357949791"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            {/* Instagram Icon */}
            <a
              href="https://www.instagram.com/pdf_play/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-instagram"></i>
            </a>
            {/* Twitter/X Icon */}
            <a
              href="https://x.com/pdfplay149687"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-twitter"></i>
            </a>
            {/* YouTube Icon */}
            <a
              href="https://www.youtube.com/@PDF_Play"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} PDF Play. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
